module.exports = __webpack_public_path__ + "static/media/3.74d13034.jpg";